import { gsap } from 'gsap';
import { isTouch } from '../utils';

const CONFIG = {
    duration: 0.3,
    ease: 'power3.out',
};

const INTERACTIVE = [
    'a',
    'button',
    '.swiper-pagination',
].join(', ');

let el: HTMLElement | null = null;
let currentModifier: string | null = null;

export const init = (): void => {
    if (isTouch()) return;
    createDOM();
    bindEvents();
};

export const destroy = (): void => {
    el?.remove();
    el = null;
};

const createDOM = (): void => {
    el = document.createElement('div');
    el.className = 'cursor';
    document.body.appendChild(el);
};

export const setModifier = (modifier: string | null): void => {
    if (!el) return;

    if (currentModifier) {
        el.classList.remove(`cursor--${currentModifier}`);
    }

    if (modifier) {
        el.classList.add(`cursor--${modifier}`);
    }

    currentModifier = modifier;
};

const bindEvents = (): void => {
    window.addEventListener('pointermove', onPointerMove);
    document.addEventListener('mouseover', onMouseOver);
    document.addEventListener('mouseout', onMouseOut);
};

const onPointerMove = (e: PointerEvent): void => {
    if (!el) return;
    gsap.to(el, {
        duration: CONFIG.duration,
        x: e.clientX,
        y: e.clientY,
        ease: CONFIG.ease,
    });
};

const onMouseOver = (e: MouseEvent): void => {
    if (!el) return;
    const target = e.target as HTMLElement;

    const dataCursorEl = target.closest<HTMLElement>('[data-cursor]');
    if (dataCursorEl) {
        setModifier(dataCursorEl.dataset.cursor ?? null);
        return;
    }

    if (target.closest(INTERACTIVE)) {
        setModifier('grow');
    }
};

const onMouseOut = (e: MouseEvent): void => {
    if (!el) return;
    const target = e.target as HTMLElement;

    if (target.closest('[data-cursor]') || target.closest(INTERACTIVE)) {
        setModifier(null);
    }
};
